function finiteConstraint(value, fallback) {
  if (value === undefined || value === null || value === "") return fallback;
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : Number.NaN;
}

/**
 * Return the canonical value for a cleared form control.
 *
 * Only optional scalar numbers whose declared bounds include zero are safely
 * normalized. Required values, structured lists, positive-only quantities,
 * and fields whose blank state has explicit meaning remain blank.
 */
export function zeroSafeOptionalFieldValue(field, value) {
  if (value !== "" && value !== null && value !== undefined) return value;
  if (field?.type !== "number" || field.required || field.preserveBlank) return "";

  const minimum = finiteConstraint(field.min, Number.NEGATIVE_INFINITY);
  const maximum = finiteConstraint(field.max, Number.POSITIVE_INFINITY);
  if (Number.isNaN(minimum) || Number.isNaN(maximum)
    || minimum > 0 || maximum < 0) return "";
  return "0";
}
